module.exports = __webpack_public_path__ + "img/6.196e92e7.svg";